'use client'
import { disableBodyScroll, enableBodyScroll } from '@/utils/DOM'
import { useCallback, useEffect, useState } from 'react'

export const useControlPopup = (
  defaultVisible = false,
  withDisableScroll = true
) => {
  const [visible, setVisible] = useState(() => {
    if (defaultVisible && withDisableScroll) {
      disableBodyScroll()
    }
    return defaultVisible
  })

  useEffect(() => {
    if (withDisableScroll) {
      if (visible) {
        disableBodyScroll()
      } else {
        enableBodyScroll()
      }
    }
  }, [visible, withDisableScroll])

  const show = useCallback(() => {
    setVisible(true)
  }, [])

  const hide = useCallback(() => {
    setVisible(false)
  }, [])

  const toggle = useCallback(() => {
    setVisible((v) => !v)
  }, [])

  return {
    visible,
    show,
    hide,
    toggle,
  }
}
